import { v4 as uuid } from 'uuid';

export default () => {
  window.HE = window.HE || {};

  if (!window.HE.webContextCorrelationId) {
    window.HE.webContextCorrelationId = uuid();
  }

  return window.HE.webContextCorrelationId;
};
